$('.js-folding-btn').click(function(){
    $(this).next().slideToggle(400);
    $(this).toggleClass('open');
});

$('.js-folded-close').click(function(){
    $(this).parent().slideToggle(400);
    $(this).parent().siblings('.js-folding-btn').toggleClass('open');
});